"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitTransaction = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const constants_1 = require("../constants");
const logic_1 = require("../logic");
function submitTransaction({ transaction, currency, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield (0, network_1.default)({
            method: "POST",
            url: (0, logic_1.isTestnet)(currency)
                ? `${constants_1.CARDANO_TESTNET_API_ENDPOINT}/v1/transaction/submit`
                : `${constants_1.CARDANO_API_ENDPOINT}/v1/transaction/submit`,
            data: {
                transaction: transaction,
            },
        });
        return res.data.transaction;
    });
}
exports.submitTransaction = submitTransaction;
//# sourceMappingURL=submitTransaction.js.map